import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=cb3cd6e8&"
import script from "./tag.vue?vue&type=script&lang=js&"
export * from "./tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb3cd6e8')) {
      api.createRecord('cb3cd6e8', component.options)
    } else {
      api.reload('cb3cd6e8', component.options)
    }
    module.hot.accept("./tag.vue?vue&type=template&id=cb3cd6e8&", function () {
      api.rerender('cb3cd6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/tag/tag.vue"
export default component.exports